import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "C:/Users/ruffa/Documents/GitHub/learninghub/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const FeatureCard = makeShortcode("FeatureCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <FeatureCard title="Low-code integration using AI - Demo Preparation" color="dark" mdxType="FeatureCard">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "35.06944444444445%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAHABQDASIAAhEBAxEB/8QAFwABAAMAAAAAAAAAAAAAAAAAAAIDBP/EABUBAQEAAAAAAAAAAAAAAAAAAAED/9oADAMBAAIQAxAAAAHTQUnIJ//EABkQAAIDAQAAAAAAAAAAAAAAAAECAxIiMf/aAAgBAQABBQIMbS6Vu//EABYRAAMAAAAAAAAAAAAAAAAAAAEQEv/aAAgBAwEBPwGiv//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAECAQE/AUn/xAAZEAEAAgMAAAAAAAAAAAAAAAABAAIQMVH/2gAIAQEABj8CbO4L3H//xAAYEAEBAQEBAAAAAAAAAAAAAAABEQBRIf/aAAgBAQABPyFikXN7KkDO4Ayb/9oADAMBAAIAAwAAABAAD//EABYRAQEBAAAAAAAAAAAAAAAAAAERAP/aAAgBAwEBPxAa3DS7/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAERIf/aAAgBAgEBPxBOQh//xAAaEAEAAgMBAAAAAAAAAAAAAAABABEhMUFh/9oACAEBAAE/ELjUq+MYhKcBG0e8iIojqf/Z')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "banner",
          "title": "banner",
          "src": "/learninghub/static/c4ee116bcdfb6cb41f399aec2ecd8b75/2e753/low-code-banner.jpg",
          "srcSet": ["/learninghub/static/c4ee116bcdfb6cb41f399aec2ecd8b75/69549/low-code-banner.jpg 288w", "/learninghub/static/c4ee116bcdfb6cb41f399aec2ecd8b75/473e3/low-code-banner.jpg 576w", "/learninghub/static/c4ee116bcdfb6cb41f399aec2ecd8b75/2e753/low-code-banner.jpg 1152w", "/learninghub/static/c4ee116bcdfb6cb41f399aec2ecd8b75/74f4b/low-code-banner.jpg 1728w", "/learninghub/static/c4ee116bcdfb6cb41f399aec2ecd8b75/cbe2c/low-code-banner.jpg 2000w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </FeatureCard>
    <span id="place1"></span>
    <details>
      <summary>Introduction</summary>
      <br />
Data mapping is among the most important design steps in building an integration flow. This design-time task is usually the most tedious, time-consuming, complex, and error-prone because it requires deep understanding of all the data fields on the source and target systems. Building a successful data mapping also requires business analysis, domain expertise, and technical knowledge on both source and target systems.
      <br /><br />
Our goal in creating Mapping Assist was to simplify and automate data mapping. And when coupled with the extensive list of pre-built, security rich connectors, it can accelerate the delivery of value to the business through integration.
      <br /><br />
ACME Retail has acquired another business and needs to synchronize the contacts between two CRM applications. In this demo, we assist ACME using AI and low-code integration, synchronizing contact information between the Salesforce and Insightly CRM systems. We will recognize and automatically match fields with high confidence levels. We will also recommend and assist with other fields where there is lower confidence. And we will generate a transformation across the fields when the field formats are not the same. As you continue to use the Mapping Assist capability it learns from previously accepted matches to raise confidence levels in future mapping efforts.
      <br /><br />
Using AI-powered mapping, we can reduce errors and speed integration development.
      <br />
In the demo, we will execute the following steps: <br />
•	 Access the Cloud Pak for Integration environment <br />
•	 Create and implement an API-enabled flow to map the fields for 'contact' between Salesforce and Insightly CRM <br />
•	 Auto-map fields wherever the matching confidence is above 80% <br />
•	 Generate a data transformation when the field formats do not match <br />
•	 Execute the flow to see the results <br />
      <br /><br />
Let’s get started!
      <br /><br />
(Demo intro slides <a href="https://ibm.box.com/s/2j47xs97ju9tiiq2s2b1s4v6j05st51a" target="_blank" rel="noreferrer">here</a>)
      <br />
    </details>
    <details>
      <summary>1 - Accessing the environment</summary>
      <br />
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`1.1`}</strong></th>
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`Log in to Cloud Pak for Integration`}</strong></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Narration`}</strong></td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`IBM Cloud Pak for Integration is a hybrid integration solution that provides an automated lifecycle across multiple styles of enterprise integration. With IBM Cloud Pak for Integration, companies can speed integration development, reduce costs, and maintain enhanced security, governance, and availability. Let’s see IBM Cloud Pak for Integration in action. For today’s demo, we are using IBM Cloud Pak for Integration installed on the IBM cloud. Let me log in.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 1.1.1`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Log in with `}<strong parentName="td">{`Username ‘integration-admin’`}</strong>{` (1), the `}<strong parentName="td">{`Password`}</strong>{` (2) created in Demo preparation, and click `}<strong parentName="td">{`Sign In`}</strong>{`. `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "48.958333333333336%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABJ0AAASdAHeZh94AAACkElEQVQoz02S20tUURyFzx9gaKh4Je/iDOR9FCdH55IO460Zy5lR8ZI3fHBQKjXLCVOzB4XyD4heeqnA9CEoLMVblkpYjFiBEEE++BA+pDNi9bXPDqEfe3E4B86311p7K93d3XR1dUl1dHTQ1tZGc/NlmpqaaGhooLGxkdraWlwuN9XV1VRWVmIrK6OkpASTyURRURGFhYXyWVBQgOLxeOjs7KS9vZ2WlhYpl9OJw34Bt8uJ2+3iosMu3yvKyzAZi8nT5cqfDQaDlF6vR6fTkZWVhaK6OgFJN243vQNehkbHue4doffGEL2Dw/T0e/FcHaCn76aQF8clF/n5eUL55OTkSFhGRgZKa2uriNgsI9bV1YlYDnzbn1HnWOhI1YGfgP+IwPFvxJJz7/4kKSkpZGdnk5mZSXp6OlqtFkUF1dfXi45c1NTUUFFVxebqGw59PvY2Ntjf3mZvZJjDLR9/1E2OjiRwYnycpKQkCdNoNBKempqKohbvFJ2dFF5qs7E+N8+3Fy/ZefWa78sr7N4e5qdvi18CFDj0S+CYAJ6Ji0OTlibBycnJJCQkoKjOVJjdbhell2MVJ/h+aZHA22X2Vxfxr61wMPUEfuzx/0wODhIVGUliYiJxAhwbG0tUVBRKlYioOrNarfIqmC0W3s0vsrH8ibnZDyzN+1j7uMvq+ldWxLeF1R2+LGwyYyomVgDjhauYmBiio6OJiIj4B7SJmGazGaPRiNFkZObRY+5OPOfa6DT9d6a5NTbFwOgUfSPP8Hif8vDBLINXejgVclq6Cg8PlwoJCUEpFzFVZxbhTAWql9RiMeOwGrGXGKgyn8NaqKNUn8P5gmxMuWfJz9ASL6KGhYURGhpKcHCwhAUFBfEX8/PFpJWx+i4AAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "prep image210",
                  "title": "prep image210",
                  "src": "/learninghub/static/1445cf4f93645d90e7af4449b9d4e861/3cbba/prep-image210.png",
                  "srcSet": ["/learninghub/static/1445cf4f93645d90e7af4449b9d4e861/7fc1e/prep-image210.png 288w", "/learninghub/static/1445cf4f93645d90e7af4449b9d4e861/a5df1/prep-image210.png 576w", "/learninghub/static/1445cf4f93645d90e7af4449b9d4e861/3cbba/prep-image210.png 1152w", "/learninghub/static/1445cf4f93645d90e7af4449b9d4e861/5ca14/prep-image210.png 1405w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span></td>
          </tr>
        </tbody>
      </table>
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`1.2`}</strong></th>
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`View the Cloud Pak for Integration home screen`}</strong></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Narration`}</strong></td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Welcome to IBM Cloud Pak for Integration! We’re now at the home screen showing all the capabilities of the Cloud Pak brought together in one place. Specialized integration capabilities — for API management, application integration, messaging, and more — are built on top of powerful automation services. `}<br /><br />{` In this demo, we’ll use the App Connect Designer’s Mapping Assist capability to speed the transformation of complex data formats used by cloud applications, such as Salesforce and Insightly. Let’s open our App Connect Designer.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 1.2.1`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Show the home page and click `}<strong parentName="td">{`ace-designer-demo`}</strong>{`. `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "908px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "70.1388888888889%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAABJ0AAASdAHeZh94AAACE0lEQVQ4y4VU2ZIaMQz0JwSYYS6Oue9hhnsTCKSSp1R4y/9/S6dlMLW7SWofGlmy3VLLGtRsNkMYhkiSBGmaIo5jWJb1hG3bmE6nH8P6RGtDiSOkvu/D8zwEtIvFQsfESvxDUnsKK3mB7c6gXJL0/YDVaoWyrDD0PTabDeq6wTAMrDjSlZrLQv6EIXRcjKsbLHcOJRvj8VjDyDT+aDR6yn4v336QG0LXHsFxAyjHcbQ8gakgCAItV+C6ro7P5/N/EgskFmc1+t1XKOnR5XLB8XjUPZxMJqiqSster9cIl0vdR9lvmgZZlulzb6TbbAkLW0Yxe8gK2rbVrywHJZtYiUv1AlkvSSxVSvXmIZwppToefI8Kfe770Z1QCOSQXDZk72Hkydr3fE4DSQK2ZRZiOY8QLhLEYQYVcQZfKKelnJRVZpzF9D8QuX/HEySC5A614E/L8cjrWqMgcU0rfTQQ/3XstW/WzcOqC7P+YoXf2g7fuw4/OIfn8xm73Q7b7VY/zul0Ir5gy7XE5IGu1+vzjNgL/f1+D/XbdXDLCtzSGj+jDDeOz8AhH/jCklFkipWHK4pc+2VZYsXEbddqPy9zVEOPsmqhyijCZ25uWX6XxGh4YMOsMjLy9eR5fpfEVsjaEPZC2D4ImahePwhD/hk0/QZpWSORC0WhJRwOB1ZU6AvSq/unWWpf4h3bo5M8CKu+436DP+66hg0QB0QQAAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "mapping assist 1 2 1",
                  "title": "mapping assist 1 2 1",
                  "src": "/learninghub/static/af04995e80791fd95701519e61d7dec3/013af/mapping-assist-1-2-1.png",
                  "srcSet": ["/learninghub/static/af04995e80791fd95701519e61d7dec3/7fc1e/mapping-assist-1-2-1.png 288w", "/learninghub/static/af04995e80791fd95701519e61d7dec3/a5df1/mapping-assist-1-2-1.png 576w", "/learninghub/static/af04995e80791fd95701519e61d7dec3/013af/mapping-assist-1-2-1.png 908w"],
                  "sizes": "(max-width: 908px) 100vw, 908px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span></td>
          </tr>
        </tbody>
      </table>
      <br />
    </details>
    <details>
      <summary>2 - Creating the flow</summary>
      <br />
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`2.1`}</strong></th>
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`Create flows for an API`}</strong></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Narration`}</strong></td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Here we are in the designer tooling. This is where we can create all our API integration flows and manage our connectivity to our services and endpoints. As we begin, there is nothing here yet, so let’s build some integration logic. Let’s see how simple it is to create our flow for an API. First, we need to create a model for our contact.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 2.1.1`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Click `}<strong parentName="td">{`Create flows for an API`}</strong>{`. `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "46.52777777777778%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAIAAAC9o5sfAAAACXBIWXMAABJ0AAASdAHeZh94AAABJ0lEQVQoz3VQW27CQAzMVYErVOpPUa/RKmm4EGr/ICBQQPBTEI/NJvtep7NZHq1QR45lrWfsiZPh8HWU5+9vAWmaZlkWc8Tv+v6YpflHPsry5On5pSVfcc7rAKEUEXnv8VHErbjCWLKOwEgGg4FSqmkaKYRy7jSff4/H59nsVBSHr8/DpNDeoyUlkgi0KypWJf1+H3tEaAtDJMqy2u2UMdoYEuI4KbiQWgWABo21pu0ASdLr9VBpra3Rvm3lem2FQEEIKc/zGYejDjDsnMOIuxibQUPPQE9ULRZwzrZbttnw5fI0ndYKDhkI1rnoHBlTUFxsx8GYp+r6WJYhVqtDWbL9vm6a7pQ1f8DFtsEfdmJctsH9rnFTPiKI42bGWLwkLOD5T/wv/gHWB+I/pzLmGAAAAABJRU5ErkJggg==')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "mapping assist 2 1 1",
                  "title": "mapping assist 2 1 1",
                  "src": "/learninghub/static/c6d7ac0ed0c8de2121f2ed6d5ff87153/3cbba/mapping-assist-2-1-1.png",
                  "srcSet": ["/learninghub/static/c6d7ac0ed0c8de2121f2ed6d5ff87153/7fc1e/mapping-assist-2-1-1.png 288w", "/learninghub/static/c6d7ac0ed0c8de2121f2ed6d5ff87153/a5df1/mapping-assist-2-1-1.png 576w", "/learninghub/static/c6d7ac0ed0c8de2121f2ed6d5ff87153/3cbba/mapping-assist-2-1-1.png 1152w", "/learninghub/static/c6d7ac0ed0c8de2121f2ed6d5ff87153/0b124/mapping-assist-2-1-1.png 1728w", "/learninghub/static/c6d7ac0ed0c8de2121f2ed6d5ff87153/4c985/mapping-assist-2-1-1.png 2247w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 2.1.2`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Rename the API `}<strong parentName="td">{`Contact API`}</strong>{` (1), name the model `}<strong parentName="td">{`Contact`}</strong>{` (2), and click `}<strong parentName="td">{`Create model`}</strong>{` (3). `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "55.208333333333336%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABYlAAAWJQFJUiTwAAABfElEQVQoz51SzUrDQBjMA/YVCm1NjBVFsHjy5FkKguC9V8WbKIKK0lt7Uiw9CIJN2zRp05hks83/+GXBQqVU68Cwy7A73+wykizL2KlWoZTLKJdKUAoFqMUiVNJUVf0Dt4ib2N7dx97BIaSjWg1eqwW33UbQ7cKp14FeD/+FtEGpxpoO/WMAa6DDnkwwC0P4vo+Q1lWMokgwCIL5XpIVBVGSwvEYPOYLo/zAN8VFYhzFYh+EwdyQcw7P88AYm69SpVJBEsdwXYdEFz6JPxHSZNt3kGTJgp4nWmoYC0NXiHnCLMsEU2KOsePi6vUFJg3Mkabp+oaLSWJ6XoQszdZPyMSTM9ISMD4D8zkMcwzdMGDZn/B4AE4D1jSkfwtCmIYJzRijPxxB0wYYDoewLQNM7yOjc1GSwKN7qw2JORh10ry7h3V+Af3mFtPmI5qnlzg7eca1eozw6QF5Ttdxfk84o7q4to0pddJoNGB1OqIBem+Et3cLPW0CPuNLa/MF4iMarzVbw+wAAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "Script2 1 2",
                  "title": "Script2 1 2",
                  "src": "/learninghub/static/0b99aaf274e09258081cc28910c1377e/3cbba/Script2.1.2.png",
                  "srcSet": ["/learninghub/static/0b99aaf274e09258081cc28910c1377e/7fc1e/Script2.1.2.png 288w", "/learninghub/static/0b99aaf274e09258081cc28910c1377e/a5df1/Script2.1.2.png 576w", "/learninghub/static/0b99aaf274e09258081cc28910c1377e/3cbba/Script2.1.2.png 1152w", "/learninghub/static/0b99aaf274e09258081cc28910c1377e/0b124/Script2.1.2.png 1728w", "/learninghub/static/0b99aaf274e09258081cc28910c1377e/bdc8f/Script2.1.2.png 2164w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{` `}</td>
          </tr>
        </tbody>
      </table>
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`2.2`}</strong></th>
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`Create properties`}</strong></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Narration`}</strong></td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Let’s start by defining our properties. There will be an ID, FirstName, LastName, Email, Address, Phone, and Mobile. As you can see, we are developing our API based on a model. It’s completely model-driven, and we’ve just modeled our ‘Contact’ object. Next, we’ll design and implement the operation that is related to this ‘Contact’ model.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 2.2.1`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`In the property name, enter `}<strong parentName="td">{`ID`}</strong>{` and click `}<strong parentName="td">{`Add property`}</strong>{`. Repeat the same steps to include `}<strong parentName="td">{`FirstName`}</strong>{`, `}<strong parentName="td">{`LastName`}</strong>{`, `}<strong parentName="td">{`Email`}</strong>{`, `}<strong parentName="td">{`Address`}</strong>{`, `}<strong parentName="td">{`Phone`}</strong>{`, and `}<strong parentName="td">{`Mobile`}</strong>{` (1). Click `}<strong parentName="td">{`Operations`}</strong>{` (2). `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "55.90277777777778%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABYlAAAWJQFJUiTwAAABoklEQVQoz62SSW/iQBCF/XchHDgisUhcQpZL5jDil83kGECEmBh3t92L226bl6omjpBmNLlMS0/urb56Ve5kPB5juVxiPp9jMplgOp1isVj8IT5nLXpdn81muH14xM/1GslqtQKP87nD/xjJaDSCsR5CabjKw1qLpmnit65rtG2Iqo2BNxrN6YTgHELbIoQQxff7eXJDwKoOEVhoR5CG3J7Rdh06cn0SEjJX0NsX5NsNxI8nVM/POJObLiZrY/KyLOM3GQwG6DrapOxl+gax20Hu95C7LUJFCUIH58kFnddlAas1fHTeUkUVxdI5Oda0XxTFBchujBCQr3tkVJKibDLPUR5TGGdh6LKm7JYC2YmUMgIYxGX+HSgF1OFAJQo4CjK/f0FnGfX3cpllqI9KqQjkOff4G+ArFLvYbHC8v0N5YqD9AnKPOKgHeu+/B8ZyKJBL1u/HOL922AN5/W+gyFGkKQpj6a83cOyCSrbUeEsgduc+e8hl8/oayPucMBkOhxGolYTNcqhMoS4UfPaO1prL8+An9Cl+Uiye94PhrJQMfQCMhiYCE/qoawAAAABJRU5ErkJggg==')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "mapping assist 2 2 1",
                  "title": "mapping assist 2 2 1",
                  "src": "/learninghub/static/24fe1e9cbc137bcdb5b2c370352c6fe6/3cbba/mapping-assist-2-2-1.png",
                  "srcSet": ["/learninghub/static/24fe1e9cbc137bcdb5b2c370352c6fe6/7fc1e/mapping-assist-2-2-1.png 288w", "/learninghub/static/24fe1e9cbc137bcdb5b2c370352c6fe6/a5df1/mapping-assist-2-2-1.png 576w", "/learninghub/static/24fe1e9cbc137bcdb5b2c370352c6fe6/3cbba/mapping-assist-2-2-1.png 1152w", "/learninghub/static/24fe1e9cbc137bcdb5b2c370352c6fe6/0b124/mapping-assist-2-2-1.png 1728w", "/learninghub/static/24fe1e9cbc137bcdb5b2c370352c6fe6/d00c2/mapping-assist-2-2-1.png 1873w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{` `}</td>
          </tr>
        </tbody>
      </table>
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`2.3`}</strong></th>
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`Create operation`}</strong></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Narration`}</strong></td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`First, let’s select the “Create Contact” operation. This operation syncs the data from Salesforce to Insightly CRM. Let’s implement our API flow.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 2.3.1`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Click the `}<strong parentName="td">{`Select an operation to add`}</strong>{` dropdown. select `}<strong parentName="td">{`Create Contact`}</strong>{` (2). `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "47.56944444444444%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAABZ0lEQVQoz5WSTU/CQBCG+5tMDMUDFzHhoD/B38iVEA5cOHMiJIIHo2ha2rLtftDv15mVNlQx0SZPdmay+27n3XFGoxFuh0P0ej24rvsn+v2+heMbWq/cazwOHnA/uIPj+z5830MQBIiiCEIIJEnyK3Ec2z28v8l5bWpOWVZIpEKN/311Xf/IGUckGl4QQ+rM3qSUQpqmNtZa2/g7WZZZzmt5ntuzjjHGBtFBQcQSUspWWBOcM1orqsk2P6fZ73nel6DWBqGIkVH7Jf12RS0YulWQP3xzmmYIIwFjUpRl2aEgeA/r8Hs4moKMDhdGo6KYAQlUxyPVDJuDvASkKWCyCtXJqxa6nIXZHit4JC+S3Q5P4zHWkwmeZzO8zOd4WyzwOp1iv9mQmGms74qd6ApyaxS8L5f4WK3gr9c4bLeWkGIdhtjTOCjySiltvbpEK2gfhRJNwoyiVtOi6IwEzycbf+lBGliUZ/ETTpbXWdrmfzEAAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "Script2 3 1",
                  "title": "Script2 3 1",
                  "src": "/learninghub/static/f30f4c9132a274e9d51c68be930feb2e/3cbba/Script2.3.1.png",
                  "srcSet": ["/learninghub/static/f30f4c9132a274e9d51c68be930feb2e/7fc1e/Script2.3.1.png 288w", "/learninghub/static/f30f4c9132a274e9d51c68be930feb2e/a5df1/Script2.3.1.png 576w", "/learninghub/static/f30f4c9132a274e9d51c68be930feb2e/3cbba/Script2.3.1.png 1152w", "/learninghub/static/f30f4c9132a274e9d51c68be930feb2e/0b124/Script2.3.1.png 1728w", "/learninghub/static/f30f4c9132a274e9d51c68be930feb2e/6f818/Script2.3.1.png 1972w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{` `}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 2.3.2`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Click `}<strong parentName="td">{`Implement flow`}</strong>{`. `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "39.93055555555555%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAABYlAAAWJQFJUiTwAAABUklEQVQoz62Ru07DQBBF/b1BsZMgI0THB6Snp0GiQOJRgAId3xBQQDwKQA6xHe/Oene9zmXWxolS0TDS0Yzt0fXMnaC300Mcx+j3+/C1z2EUIgzDNv9BFEWIwj6G8T52Dw4RjMdjtLHCf0QwGo1ApUWaSxAplKWC1hqkCMaaBmvtVt3y+96Ypt9nw8/BYDhAzcp5UaCQEumSsBQCQhYQJBphSRKqpAZfewRRg6+7Hk/gPfBRiAJKKSjSm+3dCkoSXOWQ848ypnI1VrUDasN9Fs45FtoIrwUFT5XJHJezCc4er3H6cIWT6Tkmr/dIVIaEMnxTDgGN9+kTLo5ucHd8C81ixDatBf01uwkFlXiZLzD7/MJzkuAtTfGxFEilhbKOral56Bql0pjP2Z6F5Omr9cqNYLwXb61sDRtuqhbNpmvD3pV8rA4+mtG8Oh+lar95oY4fK3Q/1pkzPYIAAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "Script2 3 2",
                  "title": "Script2 3 2",
                  "src": "/learninghub/static/a2374391a367aeb621c6e13b400e5f51/3cbba/Script2.3.2.png",
                  "srcSet": ["/learninghub/static/a2374391a367aeb621c6e13b400e5f51/7fc1e/Script2.3.2.png 288w", "/learninghub/static/a2374391a367aeb621c6e13b400e5f51/a5df1/Script2.3.2.png 576w", "/learninghub/static/a2374391a367aeb621c6e13b400e5f51/3cbba/Script2.3.2.png 1152w", "/learninghub/static/a2374391a367aeb621c6e13b400e5f51/0b124/Script2.3.2.png 1728w", "/learninghub/static/a2374391a367aeb621c6e13b400e5f51/459f3/Script2.3.2.png 2248w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{` `}</td>
          </tr>
        </tbody>
      </table>
      <br />
    </details>
    <details>
      <summary>3 - Implementing the flow</summary>
      <br />
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`3.1`}</strong></th>
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`Adjust flow response`}</strong></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Narration`}</strong></td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Here we see our initial demo flow, which initially has just a ‘Request’ node and a ‘Response’ node. We will use the designer flow editor to edit and change our flow to add the necessary additional steps. `}<br /><br />{` Before we add to our flow, let’s adjust the response that is returned when the flow is called. This response serves to close the API flow and is a required construct. Because there is no data needed by the caller of the API flow (but a response is required), we can have a very simple response. We will add the ID to the response.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 3.1.1`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Click the `}<strong parentName="td">{`Response`}</strong>{` node. `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "32.98611111111111%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAIAAACHqfpvAAAACXBIWXMAAAsTAAALEwEAmpwYAAABOklEQVQY001QTU8CMRDdn8cGuosX8cKF3+WJiwcPJn5EvaiJHjQhakQ4CALCIu12uv3Y7nYjB5wFFV9eJjPTeW/aeruNBiGkUvGDIAzDej3cwYSQoFqr1Qj5zyrGIED6vr/XbDZbLU9KySibw+K0d37UPTl4PLyfdCJJYyu0Nam1NsvWIfsqXKqk1mYa50ykWkmvKBxjjAMfLyajz/EgGk7pTGn18Pzy9No3xghAFzvvdm+Oz+JoFg/fOCQgEoTnXCkGDkpIjb6JEhxsai6vbi+u73CGUppoPeh02vvt6H3E+j3guKuEt1wuAUCuwTFRJdAV71o4J3+RCGG1BEqBsZ8Obl6tViZNszxHMgCljbE2dw7L8qHrfknncAjj5giJqq0Yu5DI8TT6iOYchNI6c/lWnOebz/srUfUNuh5dehdZsdUAAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "mapping assist 3 0 1",
                  "title": "mapping assist 3 0 1",
                  "src": "/learninghub/static/575e5e2240fdc6196a176e3def1e379d/3cbba/mapping-assist-3-0-1.png",
                  "srcSet": ["/learninghub/static/575e5e2240fdc6196a176e3def1e379d/7fc1e/mapping-assist-3-0-1.png 288w", "/learninghub/static/575e5e2240fdc6196a176e3def1e379d/a5df1/mapping-assist-3-0-1.png 576w", "/learninghub/static/575e5e2240fdc6196a176e3def1e379d/3cbba/mapping-assist-3-0-1.png 1152w", "/learninghub/static/575e5e2240fdc6196a176e3def1e379d/fee9f/mapping-assist-3-0-1.png 1481w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 3.1.2`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Enter `}<strong parentName="td">{`ID`}</strong>{` in the `}<strong parentName="td">{`ID`}</strong>{` field (1), and select the `}<strong parentName="td">{`ID`}</strong>{` object (2). `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "44.79166666666667%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAABYlAAAWJQFJUiTwAAABmklEQVQoz4WSS0vDQBDH+0Ft+rr0ICL6RQqFHvSolx49imI9+SqC+EQPatVqk9Sm2c1udpM0f2eTRhQLDgz7mJnf7PzZUr1eR7PZRLVaRdkqY8laglWrwKpaqNVrMHETM2uj0VjolUoFK2vrWF5dRanb7cKYDjWm0RQnzin2Bz3sPR/gI3QQpCH+M6YAGeX7UqvVQpqm4Jzj5W2Inb0DuN4nuQufMzhjFzu7PYwcOjNGeQyMGedZjdn7PjmdgyDIgcY4BT5GNo77F9BKQwQi88nEw+FRH1M/hzCegwowL860z4DtdjsDhmGIJElyOCUIIRAlMXQcZ3fJLKFGISKtoJSCVBGi6LdrrVHqdDp5wRxmxjedZCihPR9Te4zJxibY5S0ExQWJxeUMKv6rpWF8A+P5S2YzSjYdaXWHI7zcPeD17Bz2m41PX5KuCh6PEKisffYA48aklAuA1GVwc43B1SXGT4/wHAecxhSUHJBuUops7GKaAlrItgAYY/RwD/t9CGd7G+7WFn0d+gW+D05SGDlMYToH/nyhuf8C8vuJfv49a6wAAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "mapping assist 3 0 2",
                  "title": "mapping assist 3 0 2",
                  "src": "/learninghub/static/f8c011408e51093079919e13d85921d6/3cbba/mapping-assist-3-0-2.png",
                  "srcSet": ["/learninghub/static/f8c011408e51093079919e13d85921d6/7fc1e/mapping-assist-3-0-2.png 288w", "/learninghub/static/f8c011408e51093079919e13d85921d6/a5df1/mapping-assist-3-0-2.png 576w", "/learninghub/static/f8c011408e51093079919e13d85921d6/3cbba/mapping-assist-3-0-2.png 1152w", "/learninghub/static/f8c011408e51093079919e13d85921d6/0b124/mapping-assist-3-0-2.png 1728w", "/learninghub/static/f8c011408e51093079919e13d85921d6/fea76/mapping-assist-3-0-2.png 1866w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{` `}</td>
          </tr>
        </tbody>
      </table>
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`3.2`}</strong></th>
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`Retrieve contacts`}</strong></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Narration`}</strong></td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Our API will be easy to create. The API will retrieve the contacts from Salesforce. For each contact that is retrieved, we will sync the data to Insightly CRM. Let’s include our pre-configured Salesforce connector and select the “Retrieve contacts” operation.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 3.2.1`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Click the `}<strong parentName="td">{`Plus`}</strong>{` icon (1). Search for the `}<strong parentName="td">{`Salesforce`}</strong>{` connector (2). `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "45.833333333333336%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAABYlAAAWJQFJUiTwAAABmUlEQVQoz3VSTUvDQBDN320phd6KTUpBEHvwrGcFvSgeLFpFET9QRKRe7EFEbWuxbUxNtpttkt3kubutNn5NGGZ28+bNm2GNQqGASqUCy7JQLBZRKpV0bprmJFomSjKfM61v98rLKpbLsm4Oi0tLmF9YgFGtVqGMMYZEfkedE+w87WGnVcPu8z5s7oKBKgT+skQ65bOzkclkwDmH67oghMAjHgZvNg5OL/A6sBGMKe4ajzg+a8PptnB8comh52msxnsEQ1fVEVBKYeRyOU3oTUG+78O2Haxu1tAbvEFEPq6vnrFV76J3WMfaxjbeyQij0cypjpNaI5vNaqmKXY3N5OWYTcYLgwA+G4P7HmJiw15eQTx0EEgBCqfxP9zI5/O6OI5juZDkaxcsCBHLDSnCvvMOh1B4XECkMInMk9Q5iqIZoZBd1a+o0YC7vo6H2yb6zUcEUgmlSvUYkVQchqF2tSYlQguZmrqbEQoxGbPThn3TQOuljd79OXgUQsgiIbguSHta6S9C1SmZdlNQEgZgo45+Sv/Z58hpwg903oreZGGlmAAAAABJRU5ErkJggg==')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "mapping assist 3 1 1",
                  "title": "mapping assist 3 1 1",
                  "src": "/learninghub/static/1d31e0fbd986eae6ab2f97305cb9c3b6/3cbba/mapping-assist-3-1-1.png",
                  "srcSet": ["/learninghub/static/1d31e0fbd986eae6ab2f97305cb9c3b6/7fc1e/mapping-assist-3-1-1.png 288w", "/learninghub/static/1d31e0fbd986eae6ab2f97305cb9c3b6/a5df1/mapping-assist-3-1-1.png 576w", "/learninghub/static/1d31e0fbd986eae6ab2f97305cb9c3b6/3cbba/mapping-assist-3-1-1.png 1152w", "/learninghub/static/1d31e0fbd986eae6ab2f97305cb9c3b6/0b124/mapping-assist-3-1-1.png 1728w", "/learninghub/static/1d31e0fbd986eae6ab2f97305cb9c3b6/2afb8/mapping-assist-3-1-1.png 1867w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 3.2.2`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`From your pre-configured Salesforce connector, select `}<strong parentName="td">{`Retrieve contacts`}</strong>{`. `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "53.125%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAIAAADwazoUAAAACXBIWXMAAAsTAAALEwEAmpwYAAABaElEQVQoz5WPy0rDQBSG83ZtTdCAjbpyqc/hkwiiLaKgIAgu1YVQrW601GrTpJdk7pNpMjMKLjyx4KKWgh8/mTmH+SZznPV6SaVaXfP8wK8HfhD4G/6q7wGu57reiuv+xi2/Xq1S297ZDbY2nXg47Id9Suh197bRPjl+Oj24P7oLH2KajPkECSKnaprnGaCUEHxCZJgoISUlxCGUcs6llAMUvYw6rdd2660d4WHKcHeEEeNpHKcIyyyDM1IIwmSCJZRgOQghWChcQfmX/dxvnF9c3VhjobXXlOHENA+bzbPLvCgwJqyEckZnOBjjmQxtzliKECEEOlBiKhjnKS7hbJ5ShkkKrWEquBsC+/KFmYK9MQbK4of8T2BsBzRjLRzSxkAAlesR1gpca2bNhSlnXiSbAdJE6EIvk4UQ8zJkWhimTGE/tLVLZLng2dayJBm+R2yc6KnSxv5HNoZFceexFz/3tGBLfg7yN4U2Pl7I4N78AAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "mapping assist 3 1 2",
                  "title": "mapping assist 3 1 2",
                  "src": "/learninghub/static/cea6b01d6dcbcb8a37f2062e866cc9b5/3cbba/mapping-assist-3-1-2.png",
                  "srcSet": ["/learninghub/static/cea6b01d6dcbcb8a37f2062e866cc9b5/7fc1e/mapping-assist-3-1-2.png 288w", "/learninghub/static/cea6b01d6dcbcb8a37f2062e866cc9b5/a5df1/mapping-assist-3-1-2.png 576w", "/learninghub/static/cea6b01d6dcbcb8a37f2062e866cc9b5/3cbba/mapping-assist-3-1-2.png 1152w", "/learninghub/static/cea6b01d6dcbcb8a37f2062e866cc9b5/0e835/mapping-assist-3-1-2.png 1289w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 3.2.3`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Select `}<strong parentName="td">{`Process 10 items from the collection`}</strong>{`. `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "52.43055555555556%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAAsTAAALEwEAmpwYAAABcklEQVQoz4VQzUvDMBzt/2rd7u60mx/n+bEP1yFMPOhNEDwLwlD04GFMBRW7mU3Tpkm6pElLu27z1w5B1OGPR/KSvJf3S4xyubzfbFar1d3a3kZla72yuV7Z2K7v1K1GvdmwLKuVl/XFYKw1rNZBu310ZKyVSpM0DWQgInmFbjro+uL1su8jHgk/CuJkkqQpCKZ5AYnjmMlU6EmSxIZpmkIIjLHneehtdHh85mCPEdJDbtcevWNMGOecnZyed27vKKWgdF3HdRzXdY0V09RaE89jjDmEvNh9yhiICGUEJsZpZub2AGHH5T4HGc0BZawWCtPZTAaBVJr48gM7wJXWAB2GAKUVrKMoAh7k+4sjuNEoFIuz+TxQKtdpyv2xlGFu+wEh5UIGCKMoS/5uDnSIqfKFUgrSVZbwu5aZQc3HYx8gBDQKUH+18Id5oYMfR89PH7bN30eK0TB/6v/mLFmpwX2v3+0OHx/QfY8OETxkmXksxCdxxQ2j76aj3QAAAABJRU5ErkJggg==')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "mapping assist 3 1 3",
                  "title": "mapping assist 3 1 3",
                  "src": "/learninghub/static/64466dd658a89ab27b41db73eb5bb878/3cbba/mapping-assist-3-1-3.png",
                  "srcSet": ["/learninghub/static/64466dd658a89ab27b41db73eb5bb878/7fc1e/mapping-assist-3-1-3.png 288w", "/learninghub/static/64466dd658a89ab27b41db73eb5bb878/a5df1/mapping-assist-3-1-3.png 576w", "/learninghub/static/64466dd658a89ab27b41db73eb5bb878/3cbba/mapping-assist-3-1-3.png 1152w", "/learninghub/static/64466dd658a89ab27b41db73eb5bb878/fee9f/mapping-assist-3-1-3.png 1481w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{` `}</td>
          </tr>
        </tbody>
      </table>
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`3.3`}</strong></th>
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`‘For each’ statement`}</strong></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Narration`}</strong></td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Now, we need to add a ‘for each’ statement because we need to retrieve all of the contacts from Salesforce. For each contact, we need to create a contact in the Insightly CRM. We’ll select the “Salesforce Contacts” object as the object to be processed.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 3.3.1`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Click the `}<strong parentName="td">{`Plus`}</strong>{` icon. `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "54.861111111111114%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAIAAADwazoUAAAACXBIWXMAAAsTAAALEwEAmpwYAAABaUlEQVQoz32S3UoCQRTH9wmtzV0WXAWhK5/DR+iqy7qLKELoEYKuQgiltETKzHK/Znfnk/no6JiVZT9mh3N2zpn/OYdxgiAIw7BWq1UqlcAL6kHYCOqwfM/3ql51yZ7Fda27u7PTaDb3Wy2n3W4jhKIoIoRcPV937i9Pe+dn/YsnNJnTJGEZYVgrrcwCKSXnfI4UZlJw5riuSynN8xz2m0GvPxmMo/HofTTNsnlRFAQTLjBC+fRlPHwsCcEYxxktSsoodaBs8CGMMXp00rntD400AtO7iDy8pkmScm3QbDbpdg8Oj9+ipFxQWBzoBTQxLvOiBAG8pMSYEswogSOwIRgWJpQsldc4vu9DM1rrUsgoyeDYugo+bayt7f7NgP9w7yrZBnHOoBWp7HQ2gQAhxOpKY76UV+JUFUStFX8vJaX5zN5MpkwQyi1qi76N/JFsfcaYHQiUZ7bzdzIXIk3TOI7h2cA8zL9AdR+vw0Nm/pB2NQAAAABJRU5ErkJggg==')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "mapping assist 3 2 1",
                  "title": "mapping assist 3 2 1",
                  "src": "/learninghub/static/7ae8a293d74ee2dbbb646bc1de88c6b2/3cbba/mapping-assist-3-2-1.png",
                  "srcSet": ["/learninghub/static/7ae8a293d74ee2dbbb646bc1de88c6b2/7fc1e/mapping-assist-3-2-1.png 288w", "/learninghub/static/7ae8a293d74ee2dbbb646bc1de88c6b2/a5df1/mapping-assist-3-2-1.png 576w", "/learninghub/static/7ae8a293d74ee2dbbb646bc1de88c6b2/3cbba/mapping-assist-3-2-1.png 1152w", "/learninghub/static/7ae8a293d74ee2dbbb646bc1de88c6b2/0e835/mapping-assist-3-2-1.png 1289w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 3.3.2`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Then, open the `}<strong parentName="td">{`Toolbox`}</strong>{` tab (1) and select the `}<strong parentName="td">{`For each`}</strong>{` statement (2). `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "47.56944444444444%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAABxklEQVQoz22R22sTQRTG9z/T3Gi1kKagvul/JNgnfRAKtuCToODlyRehoCilNRZ80pqQtDW72Zmd2Wuy+/PMxpSYeuBjLufMd77zjdftdun1ejQaDTY7G2xvdtm+1WXndo+tjS067c4CrTatVotms1mvS7TbbZo3b7Bz5y73HtzHG49GDAYDdKg5+nXMi/5LXp2+5uDoOYdnH7mIfMElvgmwcUye56RpSpZlxHJW2jLyM5RJscbgTXy/TuZZzlidczI+pS84Hn3lLBigEs2FUgTWkEaa2MbMZrOauCZNMnydY5OcQu683acHVFWFlkdKx3z35wQTRVVUUAJ5xJN3Me/7JSeHH3j4+BmxKNRRRCQwJsLaxeruvKGM7EYxrkAkh/W6LDYkScw0EgLrxjJc/p5c5dZhrcVzD8qypCiKepS5w3y+gOyV0tJME4VTTBjW07j72RpcvfPUcwa7cIXLyPIMI90K2YfDIT+/fOZ8f59gb29RUJb8L5zKK0KncklayK9aJb8aiCKnSnLzNGEmTZbN13GNsPrbtSor4m+fiIY/mL59Q7j76B8Vq5Oskl8nXEnkRmHFs1w8cX5Va/l1ZbWv4qEj/APzSdZNAXnWYwAAAABJRU5ErkJggg==')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "mapping assist 3 2 2",
                  "title": "mapping assist 3 2 2",
                  "src": "/learninghub/static/5fab93b2af3fa62b1d0947994e83a0f4/3cbba/mapping-assist-3-2-2.png",
                  "srcSet": ["/learninghub/static/5fab93b2af3fa62b1d0947994e83a0f4/7fc1e/mapping-assist-3-2-2.png 288w", "/learninghub/static/5fab93b2af3fa62b1d0947994e83a0f4/a5df1/mapping-assist-3-2-2.png 576w", "/learninghub/static/5fab93b2af3fa62b1d0947994e83a0f4/3cbba/mapping-assist-3-2-2.png 1152w", "/learninghub/static/5fab93b2af3fa62b1d0947994e83a0f4/0b124/mapping-assist-3-2-2.png 1728w", "/learninghub/static/5fab93b2af3fa62b1d0947994e83a0f4/43692/mapping-assist-3-2-2.png 1868w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 3.3.3`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Enter `}<strong parentName="td">{`Contacts`}</strong>{` in the `}<strong parentName="td">{`Select the collection of items to process`}</strong>{` field (1), and select the Salesforce `}<strong parentName="td">{`Contacts`}</strong>{` object (2). `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "55.208333333333336%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABYlAAAWJQFJUiTwAAAB0UlEQVQoz52SX2/TMBTF89lZh9RGiD+T+gI8wIZY1b72A7BJCIkH1IoJITY22qbtkjSJY8dxEieHa3ctC3vblX6yc33v8bEdp9vtYjQa4fjkGM/fvkD3tQv3zTO8+/geJ4MPOB2c2vUdw+HQYr93IzEYDDAej+H0+33sYq6W+Ml/4VL8RokajwnnyUEH51+nWCzXyEWBxaZAEkuoXCFOBNjtFeIoQCZS5LnAdHKBT+dfwLhAsIkRRsmemKVwDjqHCOJ0n/CTFJuEIaWGiHGUMqZ9NVGjLiW8dYCZtwYXkuo5klRYzJzxbCtoYivYLogSTq4UqrIgFHKZ2SaetcV29elOsL4nuMUUSVtoRP+R3qt5iHXYOXxqHUZ0THMvJpmm1Li53e4qsm2ejshUua95iLDOnW6vZwWLooDWmqihyxyKB5BSQVf03g3dn8pRLz3UNc1r3cL2aG3XHNd1rWBVVa3nD5cBFgsfobcC29B1fJvAf3mEvGqgCm2Ryog07d+md+fQCpITEYaIvQVmkwnmZ5+x/HEJ78bDarZCyCR4ruloFbiswGjUd4LGXdM0/zmkpH99jfnFdwR/buAfvQKbTpHpCkopW1OU5Z6SMCImzGj4C9V0L1c4T9kpAAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "mapping assist 3 2 3",
                  "title": "mapping assist 3 2 3",
                  "src": "/learninghub/static/ef3e24777c8361e728a3282b319e5976/3cbba/mapping-assist-3-2-3.png",
                  "srcSet": ["/learninghub/static/ef3e24777c8361e728a3282b319e5976/7fc1e/mapping-assist-3-2-3.png 288w", "/learninghub/static/ef3e24777c8361e728a3282b319e5976/a5df1/mapping-assist-3-2-3.png 576w", "/learninghub/static/ef3e24777c8361e728a3282b319e5976/3cbba/mapping-assist-3-2-3.png 1152w", "/learninghub/static/ef3e24777c8361e728a3282b319e5976/0b124/mapping-assist-3-2-3.png 1728w", "/learninghub/static/ef3e24777c8361e728a3282b319e5976/6c456/mapping-assist-3-2-3.png 1878w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{` `}</td>
          </tr>
        </tbody>
      </table>
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`3.4`}</strong></th>
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`Create contacts`}</strong></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Narration`}</strong></td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Now we are configuring our flow to connect to the Insightly CRM. Our Insightly account is pre-configured, so we select the ‘Create Contact’ operation. The Mapping Assist feature starts to work in the background, generating suggestions for us to populate the target fields in Insightly.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 3.4.1`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`In the `}<strong parentName="td">{`For each`}</strong>{` loop, click the `}<strong parentName="td">{`Plus`}</strong>{` icon. `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "39.93055555555555%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAIAAAB2/0i6AAAACXBIWXMAAAsTAAALEwEAmpwYAAABbElEQVQY02WQT0/bQBDF/UkBx44jBQTqBa7k2/TaSysEAgkhkHqoVA6gooaWJPZ6Z/bfrE1ssnHDJIgLXf20ehq9eZqZKI7j4XCYpOlOHG/1treTHf57aZL2+8z6ZdkHekm6u3/w6egwOh6N2pfWe++e3cXj5dn4/NvDydj81Q3ZtnoJYdl1TOi6RViGJRN03bk6LNom6mcD0HZaCGVsoWACkKNEa9BYAIkoQRuJGrUGRNRmkoupWBdZR7t7e18vrk8vbxz5iYDbqZ7MCkckjS8f711xB7YSwFHaOySiz19Orr7/MJYKiREvYKgqShCoBegSGSVAFVIpY6pyNq+rtm2atpnXDpSalcCGN1sUJ4nzdc7NEoWUBai8RE5lAajw9y9b5kSGnCar5CZ3E43r5rSfLUKwPDQZ8efn+GnKW3EQFyx5Q2Q34h0i7xltrbEuygaDf6tVVdfP8zkHgNJ8Dj6ecfQ/znu2veGr6hWBc4+t1lLPSAAAAABJRU5ErkJggg==')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "mapping assist 3 3 1",
                  "title": "mapping assist 3 3 1",
                  "src": "/learninghub/static/abf10d4c22adba6978125e1fb92105ce/3cbba/mapping-assist-3-3-1.png",
                  "srcSet": ["/learninghub/static/abf10d4c22adba6978125e1fb92105ce/7fc1e/mapping-assist-3-3-1.png 288w", "/learninghub/static/abf10d4c22adba6978125e1fb92105ce/a5df1/mapping-assist-3-3-1.png 576w", "/learninghub/static/abf10d4c22adba6978125e1fb92105ce/3cbba/mapping-assist-3-3-1.png 1152w", "/learninghub/static/abf10d4c22adba6978125e1fb92105ce/fee9f/mapping-assist-3-3-1.png 1481w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 3.4.2`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`In the `}<strong parentName="td">{`Applications`}</strong>{` tab, search for the `}<strong parentName="td">{`Insightly`}</strong>{` connector. `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "48.611111111111114%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAAsTAAALEwEAmpwYAAABoUlEQVQoz12RS2/TQBCA/SspbdpLzhz7H2jTSJQTEtwqUXFEfUig3lA5ABLl1Ffcxo/N2ruzb+/acXoI4yRqKatP1u7MfLMPRxu9Xr/fx++LtbWX6+s4QZZj4zm9f+Jbm1uvtrejj4eHoQ7OuBjuT66/HF2dfr48jmXCvBJB+6ZuZ7MVi9FMG+naUrch1NFgOKynrZCaa0VEQYCmjDAlQWuhtJRKW4cY63CJKKUBpNBOGRO92X/76fjs+68LYyvKxJ9cZaTUxqIwIXR8PUpJESdZnBJSMMogy8i79wd3Wc5ARjuDPQrqHg0uUE5LKLgoAZE4mZT8LodkwkjZmbikXNyM07xgmI1e7w7CtMUoCnickndO0TXCUhCCffiqf1xJIYEUnYwpJlSxKIt294ZhOkMxJur3LcrYG3BbwLvJDsoVVoNcwRfgmbEz3nl/Pp9776gIN7kD4JejjJbCGoPPU3mP/8KH/8G4tXYlu6pqmvDw0KokGZ1/G/88h3jUPZsxxtolWBPqekndNNjiScaQx0Tl9SSm6UUITRd5vuGjvEz9BcTF+5Wd2a0QAAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "mapping assist 3 3 2",
                  "title": "mapping assist 3 3 2",
                  "src": "/learninghub/static/be0d4782c24c55fb638ed005dd64968d/3cbba/mapping-assist-3-3-2.png",
                  "srcSet": ["/learninghub/static/be0d4782c24c55fb638ed005dd64968d/7fc1e/mapping-assist-3-3-2.png 288w", "/learninghub/static/be0d4782c24c55fb638ed005dd64968d/a5df1/mapping-assist-3-3-2.png 576w", "/learninghub/static/be0d4782c24c55fb638ed005dd64968d/3cbba/mapping-assist-3-3-2.png 1152w", "/learninghub/static/be0d4782c24c55fb638ed005dd64968d/f3ebc/mapping-assist-3-3-2.png 1448w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 3.4.3`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Select the `}<strong parentName="td">{`Create contact`}</strong>{` operation. `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "48.958333333333336%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAAsTAAALEwEAmpwYAAABp0lEQVQoz22RO28TQRDH7/sFyTZxRGrKNBBbRAK+BWmQoKMHRQhFERWioIAKC4iJY/t8j93ZnX3dPs6h4Bg7KRBh9NNoZmf+s6PdbHc4vLe/3x8Mdnbu9Hq9wcbu9vsDotfv34aM2vaGe/cPDrJnx8fONxr1Qizffj89+fbu9eRkCjPWSNEoF3xq22vi1ocYwCSmkvc+G43HaX2ltEFrVrIuZLWAFWhEZ5W1WhvXeOcDocz2xFhURjtPhezxk6dvzj68//jJNYGD+lraogJrHdWqop6f/8zLerZYzZZlwaCWanYxf/7yVcGBCcwOR+Na6su8oKQGzLmkgEtCUVBxcVnIZQUlh4pLSiuQ03leMmAgsweHI5/WNUgSSIVckEbV20EEIrw4M1+miEqWTJCYJgJq8gwwezgah3YtEBe1piYGQOtxVGisUEYoXQvNUVPwN9vVMHt0dPS760LwQscfK6+NpkGccWetb1yIMaZI/h/oqa1zG3HXdY0PqU2/rlJq120M+eT84vPE5Ev6npjSbTZ/FsKN2Acal8JNIYGOTG7u/K/yGpL8ARCw96FeWlM6AAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "mapping assist 3 3 3",
                  "title": "mapping assist 3 3 3",
                  "src": "/learninghub/static/aad8e47f517d8f29bb3e1a8e2a2a6918/3cbba/mapping-assist-3-3-3.png",
                  "srcSet": ["/learninghub/static/aad8e47f517d8f29bb3e1a8e2a2a6918/7fc1e/mapping-assist-3-3-3.png 288w", "/learninghub/static/aad8e47f517d8f29bb3e1a8e2a2a6918/a5df1/mapping-assist-3-3-3.png 576w", "/learninghub/static/aad8e47f517d8f29bb3e1a8e2a2a6918/3cbba/mapping-assist-3-3-3.png 1152w", "/learninghub/static/aad8e47f517d8f29bb3e1a8e2a2a6918/f3ebc/mapping-assist-3-3-3.png 1448w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{` `}</td>
          </tr>
        </tbody>
      </table>
      <br />
    </details>
    <details>
      <summary>4 - Using the Mapping Assist feature</summary>
      <br />
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`4.1`}</strong></th>
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`View suggestions`}</strong></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Narration`}</strong></td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`In the node, you can manually define the map between the Salesforce and Insightly fields. However, this is difficult because there are lots of fields, and the products will probably have different field names for the same objects. `}<br /><br />{`With Mapping Assist, you don’t need to type all of these mappings. We’ll use AI to simplify our work! Once Insightly’s ‘Create Contact’ node is added, mapping suggestions are automatically generated. The best possible matches (top suggestions) are presented, which can be automatically inserted into fields with a single click. These top suggestions have an 80% (or higher) confidence score, and the count (20+ suggestions) identifies the total number of fields that will be populated with mappings.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 4.1.1`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Point out Mapping Assist’s `}<strong parentName="td">{`Preview `}{`[20+]`}{` mapping suggestions`}</strong>{` and click on the button. `}<br /><inline-notification text="The exact number of suggestions may vary."></inline-notification>{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "70.4861111111111%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAABYlAAAWJQFJUiTwAAACIUlEQVQ4y51STW8TMRDdX5qUqEqTJiKhEvyFXJD6C7jACYkrHKoeASF6AQkRJApJeqDb/bK9Xq/3+zF2NlsUoSBh6WnGnpnn8fM4o9EI89kMk8kEw+EQoxPaT2d4RDibzq1/Oj5tMcaYYGrGrW8wPBniydljzB7O4SwWC5gVhCGUTJBUGs9/XuDZ9Rs8/foSL1YXYHUC0aTQKPCv5RwdPdh6TYMsy6HzHJESYIrDTzgCQqJTqEzbWF4UKMsKWmfQmUGBlHxbS9aZTqe4+rzEq9eXKChZiBguV/gearCQoSwqm8y4hOeH8IIIrhfg9s7HHfmM8iN+D8fo9uPmF95ffYKIJRFKuExiHSVEQt2p1ILRuU8XGLh+tCWkCwyJiXWEvV4fVQ1qPbcBJkivOIEkck52e9b6BlRUCIbA95GmKQp6Nm+7NHlOnzRUpEPARFd8CBEXUIFHcoSQUkIrBd6SdYQZ6bTrwkBIdRBcpmTTrutdHTeEvX7fJhmhjeBBxK09jLCD0ZTZDmNrncFggLqukSQ0g/QEPwjoExQU6aPU36DukSikdJbTOJkJsWNzfHzcjmGNpsgQxzGqqsL/LKNpR2i6NAOb0a9ZQhr0Zh+UVzGaTc9DRb+ck9WrFaLzczRUl1GXf3TY2LbNLWYctNb2KbvY7lL/3Ue4X65xS3C/reG+/QC5XNp4sU9YlqXVckdqCPfBNxtEqzVhYyE2N92TTfw3ZUf8vlzgcIEAAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "mapping assist 4 1 1",
                  "title": "mapping assist 4 1 1",
                  "src": "/learninghub/static/d09277cdab1c448cc8dc4d394739fbec/3cbba/mapping-assist-4-1-1.png",
                  "srcSet": ["/learninghub/static/d09277cdab1c448cc8dc4d394739fbec/7fc1e/mapping-assist-4-1-1.png 288w", "/learninghub/static/d09277cdab1c448cc8dc4d394739fbec/a5df1/mapping-assist-4-1-1.png 576w", "/learninghub/static/d09277cdab1c448cc8dc4d394739fbec/3cbba/mapping-assist-4-1-1.png 1152w", "/learninghub/static/d09277cdab1c448cc8dc4d394739fbec/e5cac/mapping-assist-4-1-1.png 1591w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span></td>
          </tr>
        </tbody>
      </table>
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`4.2`}</strong></th>
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`Apply suggestions`}</strong></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Narration`}</strong></td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`By clicking “Preview mapping suggestions”, all suggestions with a confidence score of at least 80% are automatically displayed into Insightly’s ‘Create Contact’ node. Note that there are suggestions for simple fields as well as for more complex, nested fields. Mapping Assist uses a pre-trained AI algorithm to provide intelligent, customized data map suggestions. From this interface, we can clear the suggestions, or we can accept and apply the suggestions.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 4.2.1`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Show the list of suggestions (1) and click `}<strong parentName="td">{`Apply suggestions`}</strong>{` (2). `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "75%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAABYlAAAWJQFJUiTwAAACWElEQVQ4y6VTS28TMRDeXwwH1ANKE5o0NK9WDb32xLlCcOBIFbiUqglQIBKoTUma0jSvfdjed3bzMfYmSyLlghjp04zt8TefZ2e1XC6H/YN9FPJ5FPee40n+KR7tbOExoVAqYq9SQrlSRrVaXUOtVlO+XC6jVK7gqP4ChweH0Or1OlatyX/ig/EN7wkCAeb4N9MKu7v40bnF/cMIjuPC4D4M5iHyQnheANPi0A0LU93EeKKr2GS0Zyb+4ksbg+EIXNgwTAYtXyjgU/sKN70+bNtBX+foTSwIIWC7Hl1kGBHRkPAwHGM81WHIIrRvMoHGWQv93wNwuiuLa5ntrJJqcVslcPJCyDhZy32DYs+cgulT+L4P13FSQj8IicxNcgnadjaHMAam9BSLC3WQEIm0iASj51kWo4IUc/G3GKlaxilhRJ1fVlQHG2AuwRJszEsIs4pwuiD8P/BEoRwNKZ1R75hwVmBvBl9AtoKvn2l5GmhpQRAgimJEgU994gjDkNbRZsznCtR6hWg2QxzPaewcaLs0h9JkorQ5ec/zVKJaxxTR5RTSPJeYZrDfvIZ7fp4OtWVZNNg0h9JmVIVuqEqCKrmmoYhnS+KFP228w9HOK2w9+4rmy7cAN9LiMl8rFotrCmOpkPzk+BgTUsDu+mDX17A6HbCbG9xfXuKq8RHt0xZs+trpK8jkjGqZTGZFYXIYEwL6S6zmGexBBz59vZhUz2wicF3Vueiui5ieqO4sWqEIT05OEmWLKvJwqdb4fIHJ9xbMX13wXk+Bdbtgt7fQSWnI2Bqh/JB/AMtuUb+pIRAbAAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "mapping assist 4 2 1",
                  "title": "mapping assist 4 2 1",
                  "src": "/learninghub/static/8d65821eff9f5760d49e5a6113c84514/3cbba/mapping-assist-4-2-1.png",
                  "srcSet": ["/learninghub/static/8d65821eff9f5760d49e5a6113c84514/7fc1e/mapping-assist-4-2-1.png 288w", "/learninghub/static/8d65821eff9f5760d49e5a6113c84514/a5df1/mapping-assist-4-2-1.png 576w", "/learninghub/static/8d65821eff9f5760d49e5a6113c84514/3cbba/mapping-assist-4-2-1.png 1152w", "/learninghub/static/8d65821eff9f5760d49e5a6113c84514/0f117/mapping-assist-4-2-1.png 1593w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{` `}</td>
          </tr>
        </tbody>
      </table>
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`4.3`}</strong></th>
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`Resolve warnings`}</strong></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Narration`}</strong></td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Mapping Assist’s AI algorithm sometimes finds multiple high-confidence mapping possibilities. When this occurs, we need to decide which mapping we want to accept.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 4.3.1`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`You may or may not see this situation. When this happens, a `}<strong parentName="td">{`warning`}</strong>{` message is shown. You need to resolve any/all fields where this occurs. Delete the field name that is currently mapped to the field with the warning. `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "56.25%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABcRAAAXEQHKJvM/AAAB1ElEQVQoz52RW28TMRCF978jAS+hBSG1grY8cImaG0XiP/CGBEKooiKJkux9s7bX9qZ78R7GTkIp4QlLR2fHsj/P7PEe9Y5wNZng/PUrPL44xoOzHk7fnuPdoI/L4QDj8fieJnR2PBphRHJ75P3LIQbD9/h49QHexZs+7NqgxXW5whc5wxoaHf5veQ+fPMOnz9/Aco41v8UqUdhIjYIUxRn8KMUyTBAmGfKcIU1SSK1RVRWapiY1uK0alOUGSZLAOz55AUPtZBYoCoIK5ORMSHKJgjGwNIFSGlqXkOSczmgCWFhV11BlTXWNIAi2QDtexgR4IUlqK4IxcsE4eJ5Tx8qpJkBLIMUjKHqgbVsHtnsHQNuVlQWzP6C80G5fELAhYGdalCJ2Y6LrHNQYgyzLDoG2O+fiDsp3Dwn6rzVdNHS+Je293QWilPo38ED78XmBhnOYooAR4s5JHQUlqfae2lCwDWU/8t9yQFWimM7RzGZo0xQb30cdBjBx7OpuOoWMIgKevnTt2kSFvbTT/tuO+Rv4c4aOxrINLKMM8ZpT6gqqoaEJLG0ovecnNHuJ5SpAEMb35IcRkjTbAikQsfLR3NzALBbQ379CXP9At1y4upvPISiUX8JTMHMjEL0pAAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "Error screen",
                  "title": "Error screen",
                  "src": "/learninghub/static/834a6e6915b31250f75529cfface9b23/3cbba/Error_screen.png",
                  "srcSet": ["/learninghub/static/834a6e6915b31250f75529cfface9b23/7fc1e/Error_screen.png 288w", "/learninghub/static/834a6e6915b31250f75529cfface9b23/a5df1/Error_screen.png 576w", "/learninghub/static/834a6e6915b31250f75529cfface9b23/3cbba/Error_screen.png 1152w", "/learninghub/static/834a6e6915b31250f75529cfface9b23/5dce9/Error_screen.png 1500w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 4.3.2`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Click the selection list icon next to the field (1), and select the mapping option listed with the “For Each” option from the displayed list (2). Repeat these steps for each field that has a warning. `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "55.90277777777778%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABYlAAAWJQFJUiTwAAAB7UlEQVQoz52SS0/bQBSF8+8rFVQkHl20VLAAdVNRBBSQQO2mQhVSoZCEkEAbHglO/Jqxx2MnTZqv106ogAWLjnR0Z659jr87cmlmZob9vT1WP7xnenWBFyuzLK2tsLa1zsanTXZ3dth5qN3dom5vb4vkLHV9Y0t6+2x+XKe0tLxMvvoMue551JIWmoz/WZ7vUXo5/YrD03PCQOGpjFs3ITOWKLZ0uj7tjset4+K4AWGo8D0PpRQm1hhjSJJEZOj3ezQaDUpz8wvj9FATRvFEBiXKqwlDQreLtVaMljTL+DMckChHPmpIpZ8/y1elUhkHjuTgS6CWF3ScTCShUiMdoZUuzMaMzUMJtHFALIT2QWC5XH4cqCZkhfLQ+yrKe7EQaq1lvD5pmv0Ls0LNaET1KWFuujfrB6FFT8fEOXEUMRgMJNAWd2dtgg0CzNQUjYODZwifkqY94uGoIIyEVMUpyvTwdYr+USX+ekizIFx4/XygkKmsT3haQX/+gnPXoXVxgddqE7s+gePjNy4RVJpXV5Rm5+aLCw3FGOW/yxMVI/d+4x6f4C2+w6/X6J6coGo1suavYu+f1+HmhubZGaU3bxcxMkKrfcddp/tYTgfXC2TMaDyyEPhH33COjwmqVezPS9rfj2R/JoHXNOt1/gK8KyjDPrgKyQAAAABJRU5ErkJggg==')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "Selection list",
                  "title": "Selection list",
                  "src": "/learninghub/static/421d0fb5c1eac890ba301d61c0f1bc29/3cbba/Selection_list.png",
                  "srcSet": ["/learninghub/static/421d0fb5c1eac890ba301d61c0f1bc29/7fc1e/Selection_list.png 288w", "/learninghub/static/421d0fb5c1eac890ba301d61c0f1bc29/a5df1/Selection_list.png 576w", "/learninghub/static/421d0fb5c1eac890ba301d61c0f1bc29/3cbba/Selection_list.png 1152w", "/learninghub/static/421d0fb5c1eac890ba301d61c0f1bc29/0b124/Selection_list.png 1728w", "/learninghub/static/421d0fb5c1eac890ba301d61c0f1bc29/aec32/Selection_list.png 1871w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span></td>
          </tr>
        </tbody>
      </table>
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`4.4`}</strong></th>
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`Generate a transformation`}</strong></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Narration`}</strong></td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`In some situations, a direct mapping may not be adequate, for instance the data format of the “source” does not match the data format of the “target” field. In this situation you can generate a JSONata expression to define how the source data should be presented in the target application. JSONata is a declarative open-source query and transformation language for JSON data. `}<br /><br />{` Let’s explore it with the ‘Assistant’s Name’ field. Let’s select “Generate transformation”. The ‘Generate transformation’ panel opens with five blank sources and corresponding target fields that you can use for mapping data formats. We’ll need to provide at least five examples of source and target formats for Cloud Pak for Integration to generate the transformation formula. `}<br /><br />{` Using Cloud Pak for Integration and the Mapping Assist capability, we were able to easily create a data sync between two CRM solutions without needing to write any code.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 4.4.1`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`On the `}<strong parentName="td">{`Assistant name`}</strong>{` field, click the `}<strong parentName="td">{`Assistant’s Name`}</strong>{` mapping (1) and select `}<strong parentName="td">{`Transform data format`}</strong>{` (2). `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "59.72222222222222%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABJ0AAASdAHeZh94AAACEElEQVQoz5VTS2/TQBD2XwUSkXeQiMSFQy7ce4Ub4sSBR8OhUqlEe0AiSBVqGqkgVUhISZo4G+/aa68fsf0xsyVN25xY6dOM5/HN5/XYabVa6PV6qNfrqDcaqDQf42Gjigf1ChrtJtqdNqGDDqHb7e6A402qefakhxdPn8Pp9/vgU+YFcpQ4Xp3hYDHEh9lXzHNFsf87DqsSMsBiuYIxMZSOsNIGMflxnECHBn6gLZQfWARhBEn2Oqbx+8/E+pp6HZZ9/O0HhqdnRBDjygswnvuQnoc4SaGCEHNXEFaYXLmYzuZwhYSnAks6WyzxdnAIdylsrfOoUqUXBXwdUoG2Qc0+Tdw8S4JPzZH0rMKUlPuUY1LOR4aeSZ2iHqdSrSJdlxCesgQM75+9DSUV9EpAko2NsQNu6tW2zhJmeQlP+vY+eOINfLY0mZWQCpVkVpm8X3cLTq1Ws18nyzLkeY71er31ixxJFiHh/GyG5PISSVEgoVdeU01Bea7bgHsd3j8+HNjYMAytny6mcE8+wb24wOLVS6jBABHFIx0gjFK6KrtwKMvS1vOAO4ScYLBCPmI8xujNa5x/3Mdkbw/R0RFSVpvQShFblt8l5L4dhSzbk5K+ZIzp8BTf97/g5+cTTN+/gz8awVA+1BpZml7/EOWWMKXYDmFBd8QLzvKFZ3D+S0DMBUJSZTgXRbQmxjbfJ+Tev3EkZl9oEWfRAAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "mapping assist 4 4 1",
                  "title": "mapping assist 4 4 1",
                  "src": "/learninghub/static/6a6b5b8188b841d4bdb1f8b8705fd9ef/3cbba/mapping-assist-4_4_1.png",
                  "srcSet": ["/learninghub/static/6a6b5b8188b841d4bdb1f8b8705fd9ef/7fc1e/mapping-assist-4_4_1.png 288w", "/learninghub/static/6a6b5b8188b841d4bdb1f8b8705fd9ef/a5df1/mapping-assist-4_4_1.png 576w", "/learninghub/static/6a6b5b8188b841d4bdb1f8b8705fd9ef/3cbba/mapping-assist-4_4_1.png 1152w", "/learninghub/static/6a6b5b8188b841d4bdb1f8b8705fd9ef/0b124/mapping-assist-4_4_1.png 1728w", "/learninghub/static/6a6b5b8188b841d4bdb1f8b8705fd9ef/481ea/mapping-assist-4_4_1.png 1976w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 4.4.2`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`On the `}<strong parentName="td">{`Generate transformation`}</strong>{` dialog, enter `}<strong parentName="td">{`John Lennon`}</strong>{` as the first source name, and enter `}<strong parentName="td">{`J. Lennon`}</strong>{` under `}<strong parentName="td">{`‘Assistant name’ examples (target)`}</strong>{`. Repeat the same steps to include four more assistants’ names using the same transformation format (e.g., Paul McCartney, P. McCartney; George Harrison, G. Harrison; Ringo Starr, R. Starr; Pete Best, P. Best) (1). Click `}<strong parentName="td">{`Generate transformation`}</strong>{` (2), and click `}<strong parentName="td">{`Insert transformation`}</strong>{` (3). `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1126px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "126.04166666666667%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAZCAYAAAAxFw7TAAAACXBIWXMAABYlAAAWJQFJUiTwAAAEL0lEQVQ4y3VUy24jRRRtCcRPsEDAFsmBRZQtiB07JDQSYTMJo1EkFIkfADSb4QeG72ADgpFAiM2ghIyIk0ziV7rbTmy3u93vd9s+nFttexxGLI6qquvWqXvPPdXazc0NLs4v0G630Ol0cHl5iReEjK1WC+1OW80Fsn91dQVdN5AkyRppmiKKIriuC82yLJimCSG+vb1Fvz8g+mvU30wYhoHBYFDH8pscnk6ncJwppo4Dz/MRxzG00WiIK97ebrfR63WZRZuZSRbXisQw9PXcNPtqvL6+RpexvV4P3W6H6Kpvvu9Dc3iLZU0wGo8JC2NmLGvX9RFGCYIwVmXJ7Stsrldlxyw5CkMhDHBrJRjbLzHkeuLECIIIjhshDCOl0f+CRLGQFgW0qR/B8nMig+VlmMjcy+GEOYIkgxtliNIMSZYhXiLJ7q6FKKKOESXQXApsc+JcE9RqQm1sAdcuNQulAWzEhDE2dRJY1Ewg3wI2KpTmPH2K4ZMn0MZHR5hIEJsyYZBH0V1CRp9dltGRCwmJcfV6b4WAMT5JR+fnKjHNbjaRzGbwRSf6qVos7iCvqrrMnBJQr2I+RwWs98vlesgqbLpFEYYU1GPavuchTUhaliipi4yZaESiMAjoNU/FyF65jFFgQmNdh03TK8KYt0tgwEPi+opZqQMrwqU9xGdJnKz31hBCll8TnjYR8ZArGcoBHlwRyrgijEkkGW7ubxKO1hmentYl8ymts1uWsip57TWO1WapGyW/JGR3YpL4PCANmG0ILvOcwdIQ5TeO1QKvNE6aYon9+DPRxs+ewRv0YXfbylPJaIR4OETMAJmH/Gl47KBLj3qmjmw8Qsr3n0jMEon8YI6PYZ2d8elRzGG7j1G3T2ObmHI9NUjAIDG0WrOcMfeHHZOxJkYdYxlXw1UX6ghsG5p4z08K+JF4LUNW5tQyQXRywo7G63K9OMeUz9ElZC7f/wt5z5q8gP5fz2GenDHtUxjPL9D//U/0vn8MfzJBRNJQNeQu5NsmpGnSPG1K3ZyzF7Au2hidEecdWM1LxGWBjB3MebN0OsvqUa0V6r0VZE8spbGP+LUJHLdiYMYSAwt5MFC/LnkdcrscWP3CPD9UMalr0hmSfaAexIxuEMtpOXXzwgI//OTj1KABFinKLCJJ/bwKkklwWVbqQFHQ8GWGKl/GLDNciH2EUG4GCgzsjKJXWMx5uJqrzTuYzTewqCGeFVRyZoaUsmhKH96ERYX5rHz1na7AjMrUR5EGKGL+IObM7J8jZD//SNICs4xlF2zKwcEBDg8Psbe3r7C/fxd7xIP7e/jq69+w/52OB9+08PDbFr58pOOL3V/w8e7f+PAx8NGjkmDJ29vb2NnZwdbWFhqNhho30dhq4P3GB3jvkz/w1r0h3vlMx7v3DLzN8c1PDbxxH3jt8wVe363xLzSjJCEVKyhxAAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "mapping assist 4 4 2",
                  "title": "mapping assist 4 4 2",
                  "src": "/learninghub/static/837e09b4d29d95116cc3e2546b24ab6c/87c76/mapping-assist-4_4_2.png",
                  "srcSet": ["/learninghub/static/837e09b4d29d95116cc3e2546b24ab6c/7fc1e/mapping-assist-4_4_2.png 288w", "/learninghub/static/837e09b4d29d95116cc3e2546b24ab6c/a5df1/mapping-assist-4_4_2.png 576w", "/learninghub/static/837e09b4d29d95116cc3e2546b24ab6c/87c76/mapping-assist-4_4_2.png 1126w"],
                  "sizes": "(max-width: 1126px) 100vw, 1126px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 4.4.3`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Click `}<strong parentName="td">{`Done`}</strong>{`. `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "600px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "41.66666666666667%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAIAAAB2/0i6AAAACXBIWXMAAAsTAAALEwEAmpwYAAABTklEQVQY011QyU4CQRCdz1UcSeQ7+AcPJl41McGrXjwZiXEjGAlMBmbp7up9GQZoCwxuL68r1VXvdacq6ff7lFGo6f3s5exxcDq8uny7ndA8g4JwZv7BWi3Fx8Pr7GmMSZKmx+sYQ2i405mockkqDSZ4451rQtMs8WBEWud8aIx1goAE4UNITnq965u74fMoOD+l5r0UThvvm5pCvijzkkzzYl4SwjhWMJ5fDLKilMYyLpPDTse4QEGAVExIJCZcauCSciwxTpnRVim91QhVUw6oEahRycFhJyxXhAnGFZaQmGxfQTM+QwnUlTVGKYXmLw22dmadHKVpjNHsBjKCF2VlPU6wJU7lAsbm57pvaWNxeUm320Xzeo1bi2271Fpjom07mpS0WlAGVU0YAHDuvY97bDYbFP8xf2O1arN5NZ4BfiAkQgkhcOm/NW3bfgKao7awaZrucwAAAABJRU5ErkJggg==')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "mapping assist 4 4 3",
                  "title": "mapping assist 4 4 3",
                  "src": "/learninghub/static/2ba6aa0dfe1b5228f5b86de7b494ce11/dadad/mapping-assist-4_4_3.png",
                  "srcSet": ["/learninghub/static/2ba6aa0dfe1b5228f5b86de7b494ce11/7fc1e/mapping-assist-4_4_3.png 288w", "/learninghub/static/2ba6aa0dfe1b5228f5b86de7b494ce11/a5df1/mapping-assist-4_4_3.png 576w", "/learninghub/static/2ba6aa0dfe1b5228f5b86de7b494ce11/dadad/mapping-assist-4_4_3.png 600w"],
                  "sizes": "(max-width: 600px) 100vw, 600px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span></td>
          </tr>
        </tbody>
      </table>
      <br />
    </details>
    <details>
      <summary>5 - Testing your data sync</summary>
      <br />
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`5.1`}</strong></th>
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`Check the target contacts`}</strong></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Narration`}</strong></td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Before we test our data sync flow, let’s check the contacts that we have available. Let’s open our pre-created Insightly CRM account and see the available contacts before we execute the flow. As you can see, we have approximately 20 pre-created contacts, each with pictures. After the test of our flow, we should have two or three new contacts without pictures.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 5.1.1`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Open your `}<strong parentName="td">{`Insightly`}</strong>{` home page (1). `}<br /><br />{` Open the `}<strong parentName="td">{`Contacts`}</strong>{` view (2). `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "53.81944444444444%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABYlAAAWJQFJUiTwAAACiUlEQVQozzVSu24TQRTdH+BHAggJUUCBIBJvKRRIFAREQUGVgpaCggqKpEAUdNDSQUVQAJE4hNhxDME8nJgkfsT2et/P2Zndnd3D3XUY6a7uzJw595x7V1FvTWN88yz0ayegXz4G7cpx6NdPwbg9DePeVeiz52HMnpvEnWmYxf7GaagXpzC+dBTahSkYMyfRnTmD7ssXUMzqCrzNNRiVJZgUrL4KvvkFIZ1FzQ2IZg18qwrxo1YGb6xBECb+tQm2+Ab2/btw1z/DbVRh7e1C2W02oc0voPOnhQCApBi7HlzOUCw/TjGyHOSUZ4dRYIq9F3EMDsYwhYTIctieB+VguwWzvYOYhUgTiVgkeLe0g7kH77HwfAO+z5DGHDJNkcoMMkkmbLQS2tNjyP0GUkot04Ci6TqxZyUgyybI7X6AI3PLePi6Xe45oW0mYBK55XhIfq8gj7zybm//LV4tL5VFLMuEoqoqIsYghACnEJzUZBJ1owOde6VqhyfgdJ7TeVEy0fvImx9JYQ5XcNhpQi4SmCYRWpYFl3rW7/fhODZiunBsG1kUgAc+XMbhURTd49QrTQupr0RUqcDqdOH5/sQ+tcKnXBkNh5SEaGwNMBy55aUQMVZrfWgGQywlEQqylCEmtYzFiFMJc/EDgpGKkJQnSTpxSLkShiGBOHoDH58qHdS/jyCp2Y/nq/haH5UFIpp0nh9OgkwLssn/7iGkQdqWVs5dypR4GJTiUyjs9C202hq222N6LAmclJXjWCClCcdkSZLajAb4n9x1GTa+DfCzZZC6pMQqURTBo/9HVYcEsIjcKS1LmZRVbepnr9eDYRgIgqDEOo4LFnjY7xp49HQVT56tY6y5CHwP/wCSLh77xzEU4wAAAABJRU5ErkJggg==')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "mapping assist 5 1 1",
                  "title": "mapping assist 5 1 1",
                  "src": "/learninghub/static/eb224ad378593d46b1105361135edf2a/3cbba/mapping-assist-5_1_1.png",
                  "srcSet": ["/learninghub/static/eb224ad378593d46b1105361135edf2a/7fc1e/mapping-assist-5_1_1.png 288w", "/learninghub/static/eb224ad378593d46b1105361135edf2a/a5df1/mapping-assist-5_1_1.png 576w", "/learninghub/static/eb224ad378593d46b1105361135edf2a/3cbba/mapping-assist-5_1_1.png 1152w", "/learninghub/static/eb224ad378593d46b1105361135edf2a/0b124/mapping-assist-5_1_1.png 1728w", "/learninghub/static/eb224ad378593d46b1105361135edf2a/41beb/mapping-assist-5_1_1.png 1877w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 5.1.2`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Notice that there are approximately 20 pre-created contacts, each with pictures. `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "43.05555555555555%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAABYlAAAWJQFJUiTwAAABwUlEQVQoz1WRy4oVMRCG+5lEFNGFIIIKohvBrcjAuJBZiMKAME/j1jdw51vIeMBzpntOX3NPOpf+reozHsZASDpV+fJVdRUv3iJ/fYNy9gTL6QOUk3soHx8jn79CoZnPXyN/foH06Rmtz9d9/vAQ+f1d5JP7SO/uIJ0+Qj57ivzlJaqx28Mpgf5qi77eIWqJZDWSM7QaZG/hpYATIwLlccyOPczQQU0t+u0Gw/dvED9/wE4Dqu1uB2UMQoyQSkE7D+cDUikw1q174xzmmCCNhQsReVng6XvTXaEeO6Q5otCZpdzq9+UlpmmiwxltO8DFBc7SRWdh6SGOKSmhlcQgLYSyABaEMONP3aMdNEpZsDCQ8qu2bekyGQSP6+s9LAG99+sMgewoiSc/IIyHth48OLYh4K/diF6FA5BEqrquoelCJGBHcLMC6QEy5ock2a1ASmZDadwNcMZm26DpBDK15whkQ7ZJcYaWCmYuK4ghfK6or/+Ak3ZQbEiXU0rYj3rtLY9C0P+Bc8A0TtDzIcAlMVgIAa31oZ/aH4E5ZzKj3uEwjoZN06wlZzIcCahCWW1ul8xAthzVTckMJCP+Oby/DfwL+6+eyfECdkkAAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "Script5 1 2",
                  "title": "Script5 1 2",
                  "src": "/learninghub/static/d5d66af157403f833c1a2bbf2b8e8569/3cbba/Script5.1.2.png",
                  "srcSet": ["/learninghub/static/d5d66af157403f833c1a2bbf2b8e8569/7fc1e/Script5.1.2.png 288w", "/learninghub/static/d5d66af157403f833c1a2bbf2b8e8569/a5df1/Script5.1.2.png 576w", "/learninghub/static/d5d66af157403f833c1a2bbf2b8e8569/3cbba/Script5.1.2.png 1152w", "/learninghub/static/d5d66af157403f833c1a2bbf2b8e8569/0b124/Script5.1.2.png 1728w", "/learninghub/static/d5d66af157403f833c1a2bbf2b8e8569/4ea69/Script5.1.2.png 2304w", "/learninghub/static/d5d66af157403f833c1a2bbf2b8e8569/4992e/Script5.1.2.png 2458w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{` `}</td>
          </tr>
        </tbody>
      </table>
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`5.2`}</strong></th>
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`Test the API`}</strong></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Narration`}</strong></td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`It is time to test our data sync. First, we need to start our flow. Once the flow has started, let’s test it. `}<br /><br />{` Great, our data sync is running.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 5.2.1`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Go back to Cloud Pak for Integration’s `}<strong parentName="td">{`App Connect Designer`}</strong>{` page. Start your flow. `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "600px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "52.43055555555556%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAAsTAAALEwEAmpwYAAABDklEQVQoz42Qa06FMBCFWS/CTvhvolsgMWxBN4AhPi7Bi0p88+i000JLQcsjhKto/HJ+tNOeOe1YnucBkCLPAQD/AReiyLLXJAGGluu6XEiGdSOl1lpK2bZt9wd93yAKArrrLMdxpNJ5QQiBjwLyEiiFGbrBUGaMIZq1Zdu2CTTWsSLaVvdD976pByjDsqJdpxeEEFNbc382V1UlkJ9n4UkYnF4Gx+FZkFy81OV7Q984xU95dXPt+34URUopk3RgnpLNMMj4KhQcOZdKtSNq0rg1z/mePDWbSmz9vx8shxvmXwd1MLRBjC5mIAzZNrgt5GjMR2aYWfYc3+6TODW6W2kfp+lu1sMufVzpKb7/AoUvI4+rWyRSAAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "mapping assist 5 2 1",
                  "title": "mapping assist 5 2 1",
                  "src": "/learninghub/static/0877f44d9efea6e9e513f66013bef854/dadad/mapping-assist-5_2_1.png",
                  "srcSet": ["/learninghub/static/0877f44d9efea6e9e513f66013bef854/7fc1e/mapping-assist-5_2_1.png 288w", "/learninghub/static/0877f44d9efea6e9e513f66013bef854/a5df1/mapping-assist-5_2_1.png 576w", "/learninghub/static/0877f44d9efea6e9e513f66013bef854/dadad/mapping-assist-5_2_1.png 600w"],
                  "sizes": "(max-width: 600px) 100vw, 600px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 5.2.2`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Open the `}<strong parentName="td">{`Test`}</strong>{` tab (1). Click `}<strong parentName="td">{`POST /Contact`}</strong>{` (2) and open the `}<strong parentName="td">{`Try it`}</strong>{` tab (3). `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "52.083333333333336%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAABjUlEQVQoz41SwU4CMRDdDzSePAkc5Af4AD5CDxAQMOGgxh/gzlHPiBzUA2AEBDbsdrfb7nZ5zhR2QwxRJ3lpZ9p582Zap1qtotlsol6vo1arodFoWJ9x3Wrhut22axY7Bs5pd27Q6XbhVCoV/GqLBXB3i79Mw9jVuSiXEUURZJrClxJhEMB1XXieh8X7G6bDIT6fX+D5PjabjYVPe3/vK6VgjEGsDMUEnFKxiCiOEYxGEOMxBJFOJxN4TDqbwev1IKlISEUDWhlhGFrw3phkp1CACnhwzk5OMXx8wuvVJWb9PiI6TFIDvVphPRjg4/4BkpVobdXEVDxJkhzsazpjldyVUzgvwJ3P4XIbklpXElJHu6qU4NJlwcqEgCDwePSenJHtmdwSlkolW50dn8AHJtm1saW5rpdLSBpDpuInDi0n5HnwgDmQEokl224tWJE4UKcilYN9Js1yckJWwA4nsUKtVV6VSf9rLCwnZIWr5YpeLiTigBRoikf0Db8g6DsEIjgKJWmOdDdWGoEn8A11gd+YQupWBAAAAABJRU5ErkJggg==')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "mapping assist 5 2 2",
                  "title": "mapping assist 5 2 2",
                  "src": "/learninghub/static/6f5b53444763938abef64fe55b26f1d5/3cbba/mapping-assist-5_2_2.png",
                  "srcSet": ["/learninghub/static/6f5b53444763938abef64fe55b26f1d5/7fc1e/mapping-assist-5_2_2.png 288w", "/learninghub/static/6f5b53444763938abef64fe55b26f1d5/a5df1/mapping-assist-5_2_2.png 576w", "/learninghub/static/6f5b53444763938abef64fe55b26f1d5/3cbba/mapping-assist-5_2_2.png 1152w", "/learninghub/static/6f5b53444763938abef64fe55b26f1d5/0b124/mapping-assist-5_2_2.png 1728w", "/learninghub/static/6f5b53444763938abef64fe55b26f1d5/95041/mapping-assist-5_2_2.png 1813w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 5.2.3`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Scroll down to see the body field, and click `}<strong parentName="td">{`Generate`}</strong>{` (1) to create some dummy body content. Click `}<strong parentName="td">{`Send`}</strong>{` (2), and you should see a `}<strong parentName="td">{`201 Created`}</strong>{` response (3).  `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "52.083333333333336%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAABqklEQVQoz5WSyWobQRCG52GTSJCQa47xC8SXOGAQwqARFjhP4SfwIQeBSGLNppE1mn3UPT2L/lRVMkImvrjho7da/qpu6+LiM+bzOabTqWDb9onZbCbwPe95Pse+ucGcsMnmdrHA4u4O1vsPH6GURlVVMMbgNaMjH724BR4eTmfWm7fvEG632Gw2iKIIbdui6zqh73t4noflconVaoU4jpGmqZAkCbKyRE1rNJqia5inJ1jj8Vgc8zxHSQbH41EyDbNSClmWoSgKNE1zghOXRYnAd+EnBj++3yOcTGCNRiO55KzsNCgbAr40hjs/CDH5domv1/f4dLWF/9v5q3AIyAq5j3VdiwOrdhwHrksqfB9hGEprmCAIZF9WB6q4IusGGcV4FpAVnivjh+IecgDuH5d+DifMshSKBZAbn/0XkNUprbku5IGLxHNR02NpYfecHRHvoZw18ssviKmKUw85OpcsqaRRPapdhKQyqLTBQSs0ZCd0/6C16TuYskC7j5CTIFHY0SV/gyjay5+sa+rjQSF1XITE+vEn3PUv7DxfiM7gfbJ20JJfkRX4A+hl2cLMjzKBAAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "mapping assist 5 2 3",
                  "title": "mapping assist 5 2 3",
                  "src": "/learninghub/static/c71d03cb38d78011226eb432da282576/3cbba/mapping-assist-5_2_3.png",
                  "srcSet": ["/learninghub/static/c71d03cb38d78011226eb432da282576/7fc1e/mapping-assist-5_2_3.png 288w", "/learninghub/static/c71d03cb38d78011226eb432da282576/a5df1/mapping-assist-5_2_3.png 576w", "/learninghub/static/c71d03cb38d78011226eb432da282576/3cbba/mapping-assist-5_2_3.png 1152w", "/learninghub/static/c71d03cb38d78011226eb432da282576/0b124/mapping-assist-5_2_3.png 1728w", "/learninghub/static/c71d03cb38d78011226eb432da282576/fb927/mapping-assist-5_2_3.png 1803w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span></td>
          </tr>
        </tbody>
      </table>
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`5.3`}</strong></th>
            <th parentName="tr" {...{
              "align": "left"
            }}><strong parentName="th">{`Check the data sync`}</strong></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Narration`}</strong></td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Now let’s check our new contacts. We should have at least two new contacts. Let’s refresh the ‘Contacts’ page, and here are our new contacts. Let’s check the contact to see the new ‘Assistant Name’ format. `}<br /><br />{` Great! Everything works as expected.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 5.3.1`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Go back to Insightly’s `}<strong parentName="td">{`Contacts`}</strong>{` page and refresh the page. `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "600px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "54.166666666666664%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAIAAADwazoUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB40lEQVQoz02QPW8TQRCG74dEIEHS0aCAiBJQgIomQRGi5kfRUtMQiQLKCFE4VoiRIVgURPjWt/be3X7Nfu/ZVIxtCIxGq9WsHr3PTkEeb5WHd8mjLXL/Wrm7MXl4s3pyiz7fq57tVAe36eE2fXpnenRverBN9jfLnQ2ye508uFHub168OCpE78R+/ST7H1TvpPvSz597eXjajQZ5NOi+neeLM2xz9jEN+/D+WL57A8NT/va1ffWyGZwXo8uftGkh5hlYlReQO+gWtpvXGtziVw1W+MCMk2nuuoWK+TubUSFiTNKYgozHU0qNVnXDXYjOWillCEEKgafgHC8SjAKTcnLe/yjrkumQOylFQQhhjGklJnSmfbLWKKV9CHXT4MlqLMa44hrh7Jy7LClhPKWMGQWlaME12EmttAvLNKUQU1qHGBFu21ZbB86nlHBOWet86OadQHg8HmMI2nKpwUfnnQZA7I88agCgNvII49zHjAq5W8FVVTUIGzPFDAjGgLE2pjRjbK3d4rPUS+0VjOS6lVIF51xrDas/S4d/tjj13uMiMJmtSyihTUY4hCsYcNsAgLA18Ffbg7U+RLTyK20sCfZK+x8MUOhlASg5Y41wEZNRFbFmuW3ftO1y31ILWGn/nwzwG+SIQP2T0gylAAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "mapping assist 5 3 1",
                  "title": "mapping assist 5 3 1",
                  "src": "/learninghub/static/a830912784d04fb831fca3303d068a8f/dadad/mapping-assist-5_3_1.png",
                  "srcSet": ["/learninghub/static/a830912784d04fb831fca3303d068a8f/7fc1e/mapping-assist-5_3_1.png 288w", "/learninghub/static/a830912784d04fb831fca3303d068a8f/a5df1/mapping-assist-5_3_1.png 576w", "/learninghub/static/a830912784d04fb831fca3303d068a8f/dadad/mapping-assist-5_3_1.png 600w"],
                  "sizes": "(max-width: 600px) 100vw, 600px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 5.3.2`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Explore the new contacts (without the sample_data tags).`}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "600px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "54.166666666666664%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAIAAADwazoUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB+klEQVQoz2VQS28TMRDeH1IQAnrjggoCCojCiUuLKsSZ/8SZM2fugBSgVE3Lo21C1YRkvfau11m/X+tNCkhM4IQ6mhlbmvkedoYereZbN9HDVXTvYr6+UmxcwY+vkWd38dPbePM62VojT26U27fKzbVi4yq6s4LWL6D7l/IHl4+eb2d856097Ivdd/Ljm+7rbvt5J3351B0fpMFBd9RPh3uQZq8X99/H/Q9ur6f2e/z1K/vyBTvoZ4PxhLBGp3mpnezOdDfX84WdL5i2/uxnbZzwkRrP0yL8+q3S/DstS85jTMKYDE2nJcZyPKYnp4KUskBsMtGEVKNT6HR0yn6MmwI3eR44dyGM8jqnKqROCJ4hhKqqUkfHqP+tLgjPJ3Q0UrgohkOJCzQckJMTgbHIp66mPsZRjhFt2jYJITKCMedcSYFIJV201ggpfQgVpdBpXcOlasRM6tQl5z2hM+dDN+84gKfTKWNMG8e4tSGGGM3yjLAX2xaIpBSwDUQxLqc+pjal1HVLZYwxgK0xFRPCRucsUMIqm83AJCg3EEoLY4ELwID8l1rrDEZSKqtVSWdMB2O0NgZECCHBe/DM6rrmsgHbAA7hPzCUWpZks8aE1ntvHdgM4Ap0wPYytVXWteeV1d8AZcoa+DCwLZWCB4MeUNRsGbVQXJv2nPIfFYE9lX+q42gAAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "mapping assist 5 3 2",
                  "title": "mapping assist 5 3 2",
                  "src": "/learninghub/static/9f827c6a0c3a90e019c19d47e62818d6/dadad/mapping-assist-5_3_2.png",
                  "srcSet": ["/learninghub/static/9f827c6a0c3a90e019c19d47e62818d6/7fc1e/mapping-assist-5_3_2.png 288w", "/learninghub/static/9f827c6a0c3a90e019c19d47e62818d6/a5df1/mapping-assist-5_3_2.png 576w", "/learninghub/static/9f827c6a0c3a90e019c19d47e62818d6/dadad/mapping-assist-5_3_2.png 600w"],
                  "sizes": "(max-width: 600px) 100vw, 600px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`Action`}</strong>{` `}{` `}{` 5.3.3`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Click one of the contacts without a picture (1), and show the new format of `}<strong parentName="td">{`Assistant Name`}</strong>{` based on the function we defined in the flow (2). `}<br />{` `}<span parentName="td" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "54.166666666666664%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABYlAAAWJQFJUiTwAAACQElEQVQoz01SyW4TQRCdjyEcEMqFC4glhAPLBSEhlAghvgX+Jr/AIUhIKEBky3YwiyFgYmLPvvRM9yw9PfOoaodAS6WSuqtevVevHffBJtydW/DuXYZ/5yK82xvw715C+PAKwmfbCJ5uIXxyDdHOdcS7NxDt3kT0+Cp8qne3LsDb3rDh39/E8fNHcPLRezTfpsiHB5AU+DpG/3mE/gvF8RTd9ynE8C2Wb14hOHgNyfWTDxSH0NMh6qMByvEh1bxD+ukIzmz+C16aQfVAUJSoABvK9NCUQ1EgLiTyukHVwd7p/96FAST1Ct2j1C2c1XKJ2HPRLE8ReSGqRqMpCSAXMK2GT28RReJ7SJMElVJomwatbmw2NtdA39F7DMcTAt7+PryXL3DycYTT2QRJcIK4TlB0BdxshVzlaFuDhBpElqEzBl3XnYcxRJ1OmqZwlqsVIafIoxB+EKGsWzR1BakkTGcQhiEEDS2KAlkmEGcFlKqIfUtD1qG1/gfo+74tllTkJRIN7cYQAymlzYJAlFSoqSnNc8iKJGJ9emLX971leQ64WCwQn+0mTAi46YhhTTvMLWAQBDRMoaLicD6HoF22sxl6IrJG7S0oH+5xmJ0qyV2SmJKjRW0sYE3BhQzI75JM+z0ZI/j5A+neHsrBYA14xo4Py3cUTS+pQZGrSSqs5JbkMSBLYRk81BC44iHUaBjnTPJfY3i4BeRdWYYyRxhn9Jc6aPoODMIFvGOWwua4ZKCk+4JM4m9V0G61XhvD6+H8B7JMLNUul3BZAAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "mapping assist 5 3 3",
                  "title": "mapping assist 5 3 3",
                  "src": "/learninghub/static/52ccc0d78fcef9faf10cffa0a8ea76d3/3cbba/mapping-assist-5_3_3.png",
                  "srcSet": ["/learninghub/static/52ccc0d78fcef9faf10cffa0a8ea76d3/7fc1e/mapping-assist-5_3_3.png 288w", "/learninghub/static/52ccc0d78fcef9faf10cffa0a8ea76d3/a5df1/mapping-assist-5_3_3.png 576w", "/learninghub/static/52ccc0d78fcef9faf10cffa0a8ea76d3/3cbba/mapping-assist-5_3_3.png 1152w", "/learninghub/static/52ccc0d78fcef9faf10cffa0a8ea76d3/0b124/mapping-assist-5_3_3.png 1728w", "/learninghub/static/52ccc0d78fcef9faf10cffa0a8ea76d3/20f97/mapping-assist-5_3_3.png 1790w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span></td>
          </tr>
        </tbody>
      </table>
      <br />
    </details>
    <details>
      <summary>Summary</summary>
      <br />
As we mentioned in the beginning, data mapping is difficult, time-consuming, and error-prone. In this demo, we showed how AI-powered Mapping Assist can alleviate these issues.
      <br /><br />
We auto-mapped all the fields where the matching confidence was at least 80%. Mapping Assist learns from your decisions about selected mappings, and shows these as top suggestions when a similar source and target mapping is attempted in the future -- further reducing your mapping efforts.
      <br /><br />
We also generated a data transformation by providing examples of source and target data when fields do not have the same format. AI was used to determine the pattern and generate the transformation.
      <br /><br />
Using AI-powered Mapping Assist reduced the development time and eliminated errors as ACME Retail successfully integrated the new customer contacts from their business acquisition.
      <br /><br />
Thank you for attending this presentation.
      <br />
    </details>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      